<template>
    <fade-loader v-bind="fadeLoader" class="fill-height">
        <v-layout fill-height>
            <v-container fill-height>
                <geo-layer :layers="layers" :selectedLayers="selectedLayers" @selectLayer="selectLayer" @layerUpdated="layers = $event"></geo-layer>

                <geo-view :mode="mapMode"></geo-view>
            </v-container>
        </v-layout>
    </fade-loader>
</template>

<script>
  import GeoLayer from '@/components/GeoLayer'
  import GeoView from '@/components/geoview'

  export default {
    components: { GeoLayer, GeoView },
    created () {
      this.$resolve(['layer/fetchAll'])
    },
    data () {
      return {}
    },
    methods: {
      selectLayer (data) {
        this.$store.dispatch('layer/selectOrUnselect', data)
      },
      setLayers (value) {
      }
    },
    computed: {
      layers: {
        get () {
          return this.$store.getters['layer/getAll']
        },
        set (data) {
          this.$store.dispatch('layer/setLayers', data)
        }
      },
      mapMode () {
        return this.$store.getters['geoview/getMapMode']
      },
      selectedLayers () {
        return this.$store.getters['layer/getAllSelected']
      }
    }
  }
</script>

<style scoped>
</style>
